import { useEffect, useState } from 'react';
import useGlobalFilters from '../../../hooks/useGlobalFilters';
import useTableMenu from '../../../hooks/useTableMenu';
import { AvisoObraResponse, EstadoAvisoObraEnum } from '../consts/avisoObra.types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

export const useAvisoObra = () => {
    const [avisos, setAvisos] = useState<AvisoObraResponse>({
        data: {
            data: [],
            total: 0
        }
    });
    const [isFetching, setIsFetching] = useState<boolean>(false);
    const {
        filters,
        extraFilters,
        setFilters,
        handleChangeExtraFilters,
        handleSubmitSearch,
        clearFilters
    } = useGlobalFilters();
    const avisoObraTableMenu = useTableMenu();

    const contratoOrganismoCentral = useSelector((state: RootState) => {
        const organismos = state?.auth?.user?.organismos ?? [];
        const organismoConContrato = organismos.find(
            (org) => org?.idOrganismoCentral !== null && org?.idOrganismoCentral !== undefined
        );
        return organismoConContrato?.idOrganismoCentral ?? null;
    });

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, item: any) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setSelectedItem(null);
    };

    useEffect(() => {
        setIsFetching(true);
        setTimeout(() => {
            const enumKeys = Object.keys(EstadoAvisoObraEnum).filter(
                (key) => !isNaN(Number(EstadoAvisoObraEnum[key as any]))
            );

            const items = enumKeys.map((key, index) => {
                const idEstado = Number(
                    EstadoAvisoObraEnum[key as keyof typeof EstadoAvisoObraEnum]
                );

                const isVencido = index >= enumKeys.length - 4;

                const anio = isVencido ? '2024' : '2025';

                return {
                    nroObra: `000${idEstado}`,
                    direccion: `Calle ${idEstado} Nº ${100 + idEstado}`,
                    localidad: 'Localidad Ejemplo',
                    provincia: 'Córdoba',
                    programa: 'Programa X',
                    tipoObra: 'Tipo Y',
                    fechaInicio: `01/08/${anio}`,
                    fechaFin: `31/08/${anio}`,
                    idEstado,
                    fechaAlta: '28/07/2024'
                };
            });

            setAvisos({
                data: {
                    data: items,
                    total: items.length
                }
            });
            setIsFetching(false);
        }, 500);
    }, []);
    return {
        avisos,
        isFetching,
        filters,
        extraFilters,
        anchorEl,
        selectedItem,
        handleOpenMenu,
        handleCloseMenu,
        setFilters,
        handleChangeExtraFilters,
        handleSubmitSearch,
        clearFilters,
        avisoObraTableMenu,
        contratoOrganismoCentral
    };
};
